import { render } from "./ComponentPreparationPage.vue?vue&type=template&id=1cd6c574"
import script from "./ComponentPreparationPage.vue?vue&type=script&lang=js"
export * from "./ComponentPreparationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__